export const GROUP_DESCRIPTION_LIMIT = 2000;
